import { node, text } from "~/util/dom";
import Content from "./content";
import { CONFIG } from "~/config";
import createLinkButton from "~/ui/linkbutton";
import { _ } from "~/i18n";
import { frpc } from "~/util/general";

const MAX_FIRMS = 10000;

export default class AtAddress extends Content {
	_build() {
		this._dom.list = node("ul");
		this._dom.list.addEventListener("click", this, false);
		this._dom.moreButton = createLinkButton({ innerHTML: `+ ${_("detail.content.atAddress.next")}` });
		this._dom.moreButton.addEventListener("click", this, false);
		this._dom.container.classList.add("content-ataddress");
		this._loadFirms(7, 5);
	}

	_loadFirms(count: number, limit: number) {
		// @ts-ignore
		const frpcData = frpc<{
			poi?: Array<any>;
			status: number;
			statusMessage: string;
		}>({
			url: `${CONFIG.requestUrl}/firmpoifrpc`,
			method: "ataddress",
			args: [this._data.source, parseInt(this._data.id), count, { lang: CONFIG.langPriority }],
		});

		frpcData.promise.then(data => {
			if (data?.status.toString().charAt(0) !== "2" || !data?.poi?.length) {
				return;
			}

			this._dom.list.innerHTML = "";
			this._dom.container.innerHTML = `<h3>${_("detail.content.atAddress.firms")}:</h3>`;
			this._dom.container.appendChild(this._dom.list);

			let results = data.poi as Array<any> || [];

			// pokud je vysledku limit + 1, tak nechame, pokud vic, tak orizneme na limit - to predejde tlacitko "dalsi", ktere zabira jedne radek jen proto, aby se objevil pouhy jeden radek
			if (results.length > limit + 1) {
				results = results.slice(0, limit);
				this._dom.container.appendChild(this._dom.moreButton);
			}

			results.forEach(poi => {
				const item = node("li");
				const link = node("a", { href: `//${CONFIG.BASE_URL}/?source=${poi.source}&id=${poi.id}` });

				link.setAttribute("data-log-action", "click");
				link.setAttribute("data-log-type", "atAddress");
				link.setAttribute("data-source", poi.source);
				link.setAttribute("data-id", poi.id);
				link.appendChild(text(poi.title));
				item.appendChild(link);

				this._dom.list.appendChild(item);
			});
		}, () => {});
	}

	handleEvent(event: MouseEvent) {
		// tlacitko pro nacteni vice vysledku
		if (event.target === this._dom.moreButton) {
			this._loadFirms(MAX_FIRMS, MAX_FIRMS);
		// detail firmy
		} else {
			// @ts-ignore
			if (Mapy.Util.linkToNewWindow(event)) {
				return;
			}

			const target = event.target as HTMLElement;
			const link = target.closest("a");

			if (link) {
				event.preventDefault();

				const source = link.getAttribute("data-source");
				const id = ["coor", "closure"].indexOf(source) === -1 ? parseInt(link.getAttribute("data-id")) : link.getAttribute("data-id");

				// @ts-ignore
				Mapy.getComponent("detail").setState({ source, id }).then(function afterDetailSetState() {
					// @ts-ignore
					Mapy.getComponent("history").save();
				}, () => {});
			}
		}
	}

	destroy() {
		this._dom.moreButton.removeEventListener("click", this, false);
		this._dom.list.removeEventListener("click", this, false);

		super.destroy();
	}
}
